import { Capacitor } from '@capacitor/core';

// Platform detection
export const getPlatform = () => Capacitor.getPlatform();
export const isNative = () => Capacitor.isNativePlatform();
export const isWeb = () => getPlatform() === 'web';
export const isIOS = () => getPlatform() === 'ios';
export const isAndroid = () => getPlatform() === 'android';
export const isPWA = () => {
  return window.matchMedia('(display-mode: standalone)').matches ||
         window.navigator.standalone ||
         document.referrer.includes('android-app://');
};

// Gate navigateur : phone et tablette = page store (tablette fermee le 20/08/2026).
// Repasser a true pour rouvrir le navigateur tablette (un deploy web suffit).
export const TABLET_BROWSER_ALLOWED = false;

export const getBrowserDeviceType = () => {
  const ua = navigator.userAgent;
  const isIPadAsMac = /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;
  if (/iPad/.test(ua) || isIPadAsMac) return 'tablet';
  if (/iPhone|iPod/.test(ua)) return 'phone';
  if (/Android/.test(ua)) return /Mobile/.test(ua) ? 'phone' : 'tablet';
  return 'desktop';
};

// Navigateur de bureau avec une vraie souris. Le `pointer: fine` est volontaire :
// l'equipe teste la mise en page iPhone dans Chrome avec un UA Windows et le
// tactile emule, et la le drapeau doit rester faux.
export const isDesktopBrowser = () => !isNative() && getBrowserDeviceType() === 'desktop' && typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(pointer: fine)').matches;

export const isBrowserGated = () => {
  if (isNative()) return false;
  const deviceType = getBrowserDeviceType();
  if (deviceType === 'phone') return true;
  if (deviceType === 'tablet') return !TABLET_BROWSER_ALLOWED;
  return false;
};

// Feature detection
export const supportsHaptics = () => isNative();
export const supportsNativeAudio = () => isNative();
export const supportsBackgroundAudio = () => isNative();

// Platform-specific constants
export const PLATFORM_CONFIG = {
  ios: {
    statusBarHeight: 44,
    homeIndicatorHeight: 34,
    audioLatency: 0.01
  },
  android: {
    statusBarHeight: 24,
    navigationBarHeight: 48,
    audioLatency: 0.02
  },
  web: {
    audioLatency: 0.05
  }
};
// Recul a appliquer aux elements en position fixed pour ne pas passer sous les
// barres systeme Android. Depuis l'API 35 la fenetre est edge-to-edge : la barre
// de navigation (trois boutons ou trait de geste) se dessine PAR-DESSUS la
// WebView, et un `bottom: 10px` colle la barre du bas de l'app sous les boutons
// du systeme. Le plugin SystemBars de Capacitor injecte --safe-area-inset-*,
// avec env() en repli.
// Borne a Android volontairement : sur iOS env(safe-area-inset-bottom) vaut 34px
// sur les modeles a encoche et remonterait d'autant une mise en page deja livree
// et validee sur appareil.
export const androidInset = (side) =>
  isAndroid()
    ? `var(--safe-area-inset-${side}, env(safe-area-inset-${side}, 0px))`
    : '0px';
